import {Positioner} from "@/utils/positioner";
import {AppPositioner} from "@/utils/app-positioner";
import {WebPositioner} from "@/utils/web-positioner";
import {IntegrationUtils} from "@/utils/integration-utils";

export class PositionUtils {
    private static positioner: Positioner;

    public static getPositioner(): Positioner {
        if (!PositionUtils.positioner) {
            let shift = process.env.VUE_APP_IS_MOBILE_APP === 'true' || IntegrationUtils.isYandexUser()
                || IntegrationUtils.isVkUser() || IntegrationUtils.isExeUser() || IntegrationUtils.isTelegramUser();
            PositionUtils.positioner = shift ? new AppPositioner() : new WebPositioner();
        }
        return PositionUtils.positioner;
    }
}